<p-dialog header="收取異常TMS" [(visible)]="isVisible" appendTo="body" (visibleChange)="dialogVisibleChange($event)" (onShow)="showDialog($event)"
  [modal]="true" [draggable]="false" [resizable]="false" [style]="{ width: '80%' }">


  <h2>Booking 單號：{{ bookingNo }}</h2>

  <p-table [value]="errorDatas" [(selection)]="selectedTMS" [columns]="columns" class="datatable" styleClass="p-datatable-striped p-datatable-gridlines datatable">

    <ng-template pTemplate="header" let-columns>
      <tr>
        <th style="width: 3rem">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th>
        <th *ngFor="let col of columns">
          {{col.header}}
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-rowData let-columns="columns" >
      <tr>
        <td>
          <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
        </td>
        <td>{{rowData.doNo}}</td>
        <td>{{rowData.status | optionsMapping:statusOptions | replaceNullWith:'-'}}</td>
        <td>{{rowData.errorMsg}}</td>
        <td>{{rowData.createDt | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}</td>
      </tr>
    </ng-template>
  </p-table>
  <div class="grid mt-2">
    <div class="col">
      <button pButton pRipple label="重新收取" (click)="ReSendTmsBtnClick($event)"></button>
    </div>
  </div>
</p-dialog>
